import breakpoints from '../../styles/breakpoints.json'
import { Settings } from 'react-slick'

type ResponsiveSettings = {
  breakpoint: number
  settings: Settings
}

type CustomSettings = {
  xl?: Settings
  lg?: Settings
  md?: Settings
  sm?: Settings
}

const slidesToShowMap: Record<keyof CustomSettings, Record<number, number>> = {
  xl: { 1: 1, 2: 2, 3: 3, 4: 4 },
  lg: { 1: 1, 2: 2, 3: 3, 4: 3 },
  md: { 1: 1, 2: 2, 3: 2, 4: 2 },
  sm: { 1: 1, 2: 1, 3: 1, 4: 1 }
}

const breakpointKeys: (keyof CustomSettings)[] = ['xl', 'lg', 'md', 'sm']

export const getResponsiveCarouselSettings = (
  slidesToShow: number,
  customSettings: CustomSettings = {}
): ResponsiveSettings[] => {
  return breakpointKeys.map(key => {
    const bpValue = Number(breakpoints[key])
    const breakpoint = bpValue - 1
    const value = slidesToShowMap[key][slidesToShow] ?? slidesToShow

    return {
      breakpoint,
      settings: {
        slidesToShow: value,
        slidesToScroll: value,
        ...customSettings[key]
      }
    }
  })
}
